<div class="flex flex-col gap-2 px-[8px]">
  <div class="flex flex-col gap-2 pb-3">
    <div class="grid grid-cols-3 gap-6 pt-4">
      <div class="group relative">
        <label
          for="companyTitle"
          class="absolute -top-2 z-10 bg-white px-1 text-[12px] font-semibold text-gray-700 transition-colors group-focus-within:text-black group-hover:text-gray-900 ltr:left-3 rtl:right-3"
          i18n="@@adminProductsCompanyLabel">
          Company
        </label>
        <div class="relative">
          <input
            type="text"
            id="companyTitle"
            name="companyTitle"
            [(ngModel)]="filters.companyTitle"
            (ngModelChange)="onCompanyTitleChange($event)"
            (focus)="onCompanyTitleFocus()"
            placeholder="Enter company name..."
            i18n-placeholder="@@adminCompaniesNamePlaceholder"
            class="w-full rounded-[10px] border border-gray-400 bg-white py-2.5 text-[14px] text-gray-700 transition-colors outline-none placeholder:text-gray-300 hover:border-gray-600 focus:border-black ltr:pr-4 ltr:pl-10 rtl:pr-10 rtl:pl-4" />
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="absolute top-1/2 h-5 w-5 -translate-y-1/2 text-gray-400 transition-colors group-focus-within:text-black group-hover:text-gray-600 ltr:left-3 rtl:right-3"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor">
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
          </svg>
          @if (showCompanyTitleDropdown) {
            <div
              class="border-border absolute z-20 mt-1 max-h-52 w-full overflow-y-auto rounded-[6px] border bg-white shadow-lg">
              @if (companyTitleLoading) {
                <div class="text-neutral-text px-3 py-2 text-[13px]" i18n="@@adminProductsSearching">Searching...</div>
              } @else if (!companyTitleLoading && companyTitleResults.length == 0) {
                <div class="text-neutral-text px-3 py-2 text-[13px]" i18n="@@adminCompaniesNoCompaniesFound">
                  No companies found.
                </div>
              } @else {
                @for (item of companyTitleResults; track item.id) {
                  <button
                    type="button"
                    (click)="selectCompanyTitle(item)"
                    class="block w-full px-4 py-2 text-[14px] text-gray-700 transition-colors hover:cursor-pointer hover:bg-gray-50 hover:text-black ltr:text-left rtl:text-right">
                    {{ item.name }}
                  </button>
                }
              }
            </div>
          }
        </div>
      </div>

      <div class="group relative">
        <label
          for="createdOnFrom"
          class="absolute -top-2 z-10 bg-white px-1 text-[12px] font-semibold text-gray-700 transition-colors group-focus-within:text-black group-hover:text-gray-900 ltr:left-3 rtl:right-3"
          i18n="@@adminCompaniesCreatedOnFrom">
          Created On (From)
        </label>
        <div class="relative">
          <input
            type="date"
            id="createdOnFrom"
            name="createdOnFrom"
            [(ngModel)]="filters.createdOnFrom"
            placeholder="mm/dd/yyyy"
            i18n-placeholder="@@adminCompaniesDatePlaceholder"
            class="w-full appearance-none rounded-[10px] border border-gray-400 bg-white px-4 py-2.5 text-[14px] text-gray-700 transition-colors outline-none placeholder:text-gray-400 hover:cursor-text hover:border-gray-600 focus:border-black" />
        </div>
      </div>

      <div class="group relative">
        <label
          for="createdOnTo"
          class="absolute -top-2 z-10 bg-white px-1 text-[12px] font-semibold text-gray-700 transition-colors group-focus-within:text-black group-hover:text-gray-900 ltr:left-3 rtl:right-3"
          i18n="@@adminCompaniesCreatedOnTo">
          Created On (To)
        </label>
        <div class="relative">
          <input
            type="date"
            id="createdOnTo"
            name="createdOnTo"
            [(ngModel)]="filters.createdOnTo"
            placeholder="mm/dd/yyyy"
            i18n-placeholder="@@adminCompaniesDatePlaceholder"
            class="w-full appearance-none rounded-[10px] border border-gray-400 bg-white px-4 py-2.5 text-[14px] text-gray-700 transition-colors outline-none placeholder:text-gray-400 hover:cursor-text hover:border-gray-600 focus:border-black" />
        </div>
      </div>
    </div>
  </div>

  <div class="footer-border mt-4 flex justify-between border-t pt-4">
    <div class="flex flex-col gap-1.5 pt-4">
      <div class="group relative max-w-[275px]">
        <label
          for="orderBy"
          class="absolute -top-2 z-10 bg-white px-1 text-[12px] font-semibold text-gray-700 transition-colors group-focus-within:text-black group-hover:text-gray-900 ltr:left-3 rtl:right-3"
          i18n="@@adminProductsSortBy">
          Sort By
        </label>
        <div class="flex gap-2">
          <div class="relative w-full">
            <select
              name="orderBy"
              id="orderBy"
              [(ngModel)]="filters.orderBy"
              class="w-full appearance-none rounded-[10px] border border-gray-400 bg-white py-2.5 text-[14px] text-gray-700 transition-colors outline-none hover:cursor-pointer hover:border-gray-600 focus:border-black ltr:pr-10 ltr:pl-4 rtl:pr-4 rtl:pl-10">
              <option value="TITLE" i18n="@@adminProductsCompanyLabel">Company</option>
              <option value="CREATION_DATE" i18n="@@adminCompaniesSortCreatedDate">Created Date</option>
            </select>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="pointer-events-none absolute top-1/2 h-5 w-5 -translate-y-1/2 text-black ltr:right-3 rtl:left-3"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
            </svg>
          </div>
          <button
            (click)="toggleSortOrder()"
            class="w-[150px] rounded-[10px] border border-gray-400 bg-white px-2.5 py-2.5 text-[14px] font-[500] text-gray-700 transition-colors hover:cursor-pointer hover:border-gray-600 hover:bg-gray-50 focus:border-black focus:outline-none">
            @if (filters.orderDir == "DESC") {
              <span i18n="@@adminCategoriesSortDesc">DESC</span>
            } @else {
              <span i18n="@@adminCategoriesSortAsc">ASC</span>
            }
          </button>
        </div>
      </div>
    </div>
    <div class="col-span-2 flex items-end justify-end gap-3">
      <button
        (click)="resetFilters()"
        class="border-primary text-primary hover-bg-primary-10 rounded-[6px] border px-5 py-1.5 text-[13px] font-[500] hover:cursor-pointer">
        <span i18n="@@adminProductsResetButton">Clear</span>
      </button>
      <button
        (click)="applyFilters()"
        class="bg-primary hover-bg-primary-hover rounded-[6px] px-5 py-1.5 text-[13px] font-[500] text-white hover:cursor-pointer">
        <span i18n="@@adminCompaniesSubmitButton">Apply</span>
      </button>
    </div>
  </div>

  @if (loading()) {
    <div class="border-border mt-2 flex items-center justify-center rounded-[8px] border bg-white py-12 shadow-sm">
      <p class="text-neutral-text text-[14px]" i18n="@@adminCompaniesLoading">Loading companies...</p>
    </div>
  } @else if (errorGettingCompanies()) {
    <div class="border-border mt-2 flex items-center justify-center rounded-[8px] border bg-white py-12 shadow-sm">
      <p class="text-neutral-text text-[14px]" i18n="@@adminCompaniesErrorLoading">
        Error loading companies. Please try again.
      </p>
    </div>
  } @else {
    <app-tables
      [headerItems]="tableHeaderData()"
      [rows]="rows()"
      (toggleDropdown)="toggleDropdown($event)"
      [currentActions]="currentActions()"
      [bordered]="true"
      (actionTrigger)="handleAction($any($event))" />
    <!-- <div class="mt-2 overflow-visible rounded-[8px] border border-[#E5E7EB] bg-white shadow-sm">
      <table class="w-full text-sm text-gray-500">
        <thead class="bg-[#F3F4F6] text-xs font-[600] text-[#374151] uppercase">
          <tr>
            <th class="px-6 py-3 ltr:text-left rtl:text-right">#</th>
            <th class="px-6 py-3 ltr:text-left rtl:text-right" i18n="@@adminCompaniesTableHeaderName">Company Name</th>
            <th class="px-6 py-3 ltr:text-left rtl:text-right" i18n="@@adminCompaniesTableHeaderDateCreated">Date Created</th>
            <th class="px-6 py-3 ltr:text-right rtl:text-left w-[100px]"></th>
          </tr>
        </thead>
        <tbody>
          @if (paginatedCompanies.length === 0) {
            <tr class="border-b border-[#E5E7EB] bg-white">
              <td colspan="4" class="px-6 py-4 text-center text-[14px] text-[#6B7280]" i18n="@@adminCompaniesNoCompaniesFound">
                No companies found.
              </td>
            </tr>
          } @else {
            @for (company of paginatedCompanies; track company.id; let i = $index; let count = $count) {
              <tr class="border-b border-[#E5E7EB] bg-white hover:bg-gray-50">
                <td class="px-6 py-4 font-medium text-gray-900 ltr:text-left rtl:text-right">{{ i + 1 + (currentPage - 1) * itemsPerPage }}</td>
                <td class="px-6 py-4 font-medium text-gray-900 ltr:text-left rtl:text-right">{{ getCompanyTitle(company) }}</td>
                <td class="px-6 py-4 text-gray-900 ltr:text-left rtl:text-right">
                  <span class="mb-1 block">{{ company.createdOn | date }}</span>
                  <span class="block w-full text-xs">{{ company.createdBy.fullName }}</span>
                </td>
                <td class="px-6 py-4 ltr:pr-9 rtl:pl-9 w-[100px]">
                  <div class="flex items-center ltr:justify-end rtl:justify-start">
                    <div class="relative inline-flex items-center">
                      <button
                        (click)="toggleDropdown(company.id, $event)"
                        class="flex h-[28px] w-[28px] items-center justify-center rounded-[6px] text-gray-600 hover:cursor-pointer hover:bg-[#E5E7EB] hover:text-gray-900">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round">
                          <circle cx="12" cy="12" r="1"></circle>
                          <circle cx="12" cy="5" r="1"></circle>
                          <circle cx="12" cy="19" r="1"></circle>
                        </svg>
                      </button>
                      @if (activeDropdownId() == company.id) {
                        <div
                          [class.top-full]="i < count - 2"
                          [class.mt-1]="i < count - 2"
                          [class.bottom-full]="i >= count - 2"
                          [class.mb-1]="i >= count - 2"
                          class="absolute  ltr:right-6 rtl:left-6 z-50 flex w-48 flex-col gap-1 rounded-md border border-gray-200 bg-white p-1 shadow-lg">
                          <button
                            (click)="handleAction('Edit Company', company)"
                            class="w-full rounded-[4px] px-3 py-2 ltr:text-left rtl:text-right text-[13px] text-gray-700 hover:cursor-pointer hover:bg-gray-50">
                            <span i18n="@@adminCompaniesActionEdit">Edit Company</span>
                          </button>
                          <button
                            (click)="handleAction('View Company Details', company)"
                            class="w-full rounded-[4px] px-3 py-2 ltr:text-left rtl:text-right text-[13px] text-gray-700 hover:cursor-pointer hover:bg-gray-50">
                            <span i18n="@@adminCompaniesActionView">View Company Details</span>
                          </button>
                          @if (company.isActive) {
                            <button
                              (click)="handleAction('Deactivate Company', company)"
                              class="w-full rounded-[4px] px-3 py-2 ltr:text-left rtl:text-right text-[13px] text-gray-700 hover:cursor-pointer hover:bg-gray-50">
                              <span i18n="@@adminCompaniesActionDeactivate">Deactivate Company</span>
                            </button>
                          } @else {
                            <button
                              (click)="handleAction('Activate Company', company)"
                              class="w-full rounded-[4px] px-3 py-2 ltr:text-left rtl:text-right text-[13px] text-gray-700 hover:cursor-pointer hover:bg-gray-50">
                              <span i18n="@@adminCompaniesActionActivate">Activate Company</span>
                            </button>
                          }
                          <button
                            (click)="handleAction('Delete Company', company)"
                            class="w-full rounded-[4px] px-3 py-2 ltr:text-left rtl:text-right text-[13px] text-gray-700 hover:cursor-pointer hover:bg-gray-50">
                            <span i18n="@@adminCompaniesActionDelete">Delete Company</span>
                          </button>
                        </div>
                      }
                    </div>
                  </div>
                </td>
              </tr>
            }
          }
        </tbody>
      </table>
    </div> -->
  }

  <div class="mt-4 flex items-center justify-between">
    <div class="text-[14px]">
      <span i18n="@@adminProductsPaginationShowing">Showing</span>
      <span class="text-primary mx-1">{{ startItem }}-{{ endItem }}</span>
      <span i18n="@@adminProductsPaginationOf">of</span>
      <span class="text-primary mx-1">{{ totalItems }}</span>
    </div>
    <div class="flex items-center gap-1">
      <button
        (click)="previousPage()"
        [disabled]="currentPage == 1"
        [class.opacity-50]="currentPage == 1"
        [class.cursor-not-allowed]="currentPage == 1"
        class="border-border hover-bg-surface-subtle flex h-[32px] w-[32px] items-center justify-center rounded-[6px] border hover:cursor-pointer disabled:hover:bg-transparent">
        @if (isArabic()) {
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round">
            <polyline points="9 18 15 12 9 6"></polyline>
          </svg>
        } @else {
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round">
            <polyline points="15 18 9 12 15 6"></polyline>
          </svg>
        }
      </button>
      @if (totalPages <= 5) {
        @for (page of getPageNumbers(); track page) {
          @if (currentPage == page) {
            <button
              (click)="goToPage(page)"
              class="border-border bg-primary flex h-[32px] w-[32px] items-center justify-center rounded-[6px] border text-[14px] font-[500] text-white hover:cursor-pointer">
              {{ page }}
            </button>
          } @else {
            <button
              (click)="goToPage(page)"
              class="border-border hover-bg-surface-subtle flex h-[32px] w-[32px] items-center justify-center rounded-[6px] border text-[14px] font-[500] hover:cursor-pointer">
              {{ page }}
            </button>
          }
        }
      } @else {
        @if (currentPage == 1) {
          <button
            (click)="goToPage(1)"
            class="border-border bg-primary flex h-[32px] w-[32px] items-center justify-center rounded-[6px] border text-[14px] font-[500] text-white hover:cursor-pointer">
            1
          </button>
        } @else {
          <button
            (click)="goToPage(1)"
            class="border-border hover-bg-surface-subtle flex h-[32px] w-[32px] items-center justify-center rounded-[6px] border text-[14px] font-[500] hover:cursor-pointer">
            1
          </button>
        }
        @if (currentPage > 3) {
          <span class="px-1 text-[14px]">...</span>
        }
        @if (currentPage > 2 && currentPage < totalPages - 1) {
          <button
            (click)="goToPage(currentPage - 1)"
            class="border-border hover-bg-surface-subtle flex h-[32px] w-[32px] items-center justify-center rounded-[6px] border text-[14px] font-[500] hover:cursor-pointer">
            {{ currentPage - 1 }}
          </button>
        }
        @if (currentPage != 1 && currentPage != totalPages) {
          <button
            (click)="goToPage(currentPage)"
            class="border-border bg-primary flex h-[32px] w-[32px] items-center justify-center rounded-[6px] border text-[14px] font-[500] text-white hover:cursor-pointer">
            {{ currentPage }}
          </button>
        }
        @if (currentPage < totalPages - 2) {
          <button
            (click)="goToPage(currentPage + 1)"
            class="border-border hover-bg-surface-subtle flex h-[32px] w-[32px] items-center justify-center rounded-[6px] border text-[14px] font-[500] hover:cursor-pointer">
            {{ currentPage + 1 }}
          </button>
        }
        @if (currentPage < totalPages - 2) {
          <span class="px-1 text-[14px]">...</span>
        }
        @if (currentPage == totalPages) {
          <button
            (click)="goToPage(totalPages)"
            class="border-border bg-primary flex h-[32px] w-[32px] items-center justify-center rounded-[6px] border text-[14px] font-[500] text-white hover:cursor-pointer">
            {{ totalPages }}
          </button>
        } @else {
          <button
            (click)="goToPage(totalPages)"
            class="border-border hover-bg-surface-subtle flex h-[32px] w-[32px] items-center justify-center rounded-[6px] border text-[14px] font-[500] hover:cursor-pointer">
            {{ totalPages }}
          </button>
        }
      }
      <button
        (click)="nextPage()"
        [disabled]="currentPage == totalPages"
        [class.opacity-50]="currentPage == totalPages"
        [class.cursor-not-allowed]="currentPage == totalPages"
        class="border-border hover-bg-surface-subtle flex h-[32px] w-[32px] items-center justify-center rounded-[6px] border hover:cursor-pointer disabled:hover:bg-transparent">
        @if (isArabic()) {
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round">
            <polyline points="15 18 9 12 15 6"></polyline>
          </svg>
        } @else {
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round">
            <polyline points="9 18 15 12 9 6"></polyline>
          </svg>
        }
      </button>
    </div>
  </div>

  @if (showSuccessMessage) {
    <div class="fixed top-6 right-6 z-50">
      <div class="bg-green flex items-center gap-3 rounded-[8px] px-6 py-4 shadow-lg">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round">
          <polyline points="20 6 9 17 4 12"></polyline>
        </svg>
        <p class="text-[14px] font-[500] text-white" i18n="@@adminCompaniesDeleteSuccess">
          Company deleted successfully!
        </p>
      </div>
    </div>
  }

  @if (showActivationDialog().status) {
    <div
      class="fixed inset-0 z-50 flex items-center justify-center"
      style="background-color: rgba(175, 175, 175, 0.5)"
      (click)="closeDeleteDialog()">
      <div
        class="flex w-[400px] flex-col items-center gap-6 rounded-[12px] bg-white p-8 shadow-lg"
        (click)="$event.stopPropagation()">
        <div class="bg-danger-bg flex h-[80px] w-[80px] items-center justify-center rounded-full">
          @if (showActivationDialog().type === "activation") {
            <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24">
              <g class="stroke-danger-text" fill="none" stroke-width="2">
                <circle cx="12" cy="12" r="9" />
                <path d="M18 18L6 6" />
              </g>
            </svg>
          } @else {
            <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24">
              <path
                class="fill-danger-text stroke-danger-text"
                d="M23 12c0 6.075-4.925 11-11 11S1 18.075 1 12S5.925 1 12 1s11 4.925 11 11M9.305 18.11l9.402-9.403l-1.414-1.414l-7.883 7.883l-2.476-3.01l-1.511 1.31l3.882 4.633z"
                stroke-width="0.5" />
            </svg>
          }
        </div>
        @if (showActivationDialog().type === "activation") {
          <div class="flex flex-col items-center gap-2 text-center">
            <h2 class="text-black-soft text-[20px] font-[600]" i18n="@@adminCompaniesDeactivateTitle">
              Deactivate Company?
            </h2>
            <p class="text-neutral-text text-[14px]">
              <span i18n="@@adminCompaniesDeactivateConfirm">Are you sure you want to deactivate</span>
              <span class="text-primary font-[600]">{{ companyToDelete?.titleEn }}</span>
              ?
            </p>
          </div>
        } @else {
          <div class="flex flex-col items-center gap-2 text-center">
            <h2 class="text-black-soft text-[20px] font-[600]" i18n="@@adminCompaniesActivateTitle">
              Activate Company
            </h2>
            <p class="text-neutral-text text-[14px]">
              <span i18n="@@adminCompaniesActivateConfirm">Are you sure you want to activate?</span>
              <span class="text-primary font-[600]">{{ companyToDelete?.titleEn }}</span>
              ?
            </p>
          </div>
        }
        <div class="flex w-full gap-3">
          <button
            (click)="closeActivationDialog()"
            class="border-border text-black-soft hover-bg-surface-subtle flex-1 rounded-[6px] border bg-white px-6 py-3 text-[14px] font-[500] hover:cursor-pointer">
            <span i18n="@@adminProductsDeleteCancel">Cancel</span>
          </button>
          @if (showActivationDialog().type === "activation") {
            <button
              (click)="deactivateCompanyFn()"
              class="bg-primary hover-bg-primary-hover flex-1 rounded-[6px] px-6 py-3 text-[14px] font-[500] text-white hover:cursor-pointer">
              <span i18n="@@adminCompaniesDeactivateButton">Deactivate</span>
            </button>
          } @else {
            <button
              (click)="activateCompany()"
              class="bg-primary hover-bg-primary-hover flex-1 rounded-[6px] px-6 py-3 text-[14px] font-[500] text-white hover:cursor-pointer">
              <span i18n="@@adminCompaniesActivateButton">Activate</span>
            </button>
          }
        </div>
      </div>
    </div>
  }

  @if (showDeleteDialog) {
    <div
      class="fixed inset-0 z-50 flex items-center justify-center"
      style="background-color: rgba(175, 175, 175, 0.5)"
      (click)="closeDeleteDialog()">
      <div
        class="flex w-[400px] flex-col items-center gap-6 rounded-[12px] bg-white p-8 shadow-lg"
        (click)="$event.stopPropagation()">
        <div class="bg-danger-bg flex h-[80px] w-[80px] items-center justify-center rounded-full">
          <svg
            class="stroke-danger-text"
            xmlns="http://www.w3.org/2000/svg"
            width="48"
            height="48"
            viewBox="0 0 24 24"
            fill="none"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round">
            <polyline points="3 6 5 6 21 6"></polyline>
            <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
            <line x1="10" y1="11" x2="10" y2="17"></line>
            <line x1="14" y1="11" x2="14" y2="17"></line>
          </svg>
        </div>
        <div class="flex flex-col items-center gap-2 text-center">
          <h2 class="text-black-soft text-[20px] font-[600]" i18n="@@adminCompaniesDeleteTitle">Delete Company?</h2>
          <p class="text-neutral-text text-[14px]">
            <span i18n="@@adminProductsDeleteConfirm">Are you sure you want to delete</span>
            <span class="text-primary font-[600]">{{ companyToDelete?.titleEn }}</span>
            ?
          </p>
        </div>
        <div class="flex w-full gap-3">
          <button
            (click)="closeDeleteDialog()"
            class="border-border text-black-soft hover-bg-surface-subtle flex-1 rounded-[6px] border bg-white px-6 py-3 text-[14px] font-[500] hover:cursor-pointer">
            <span i18n="@@adminProductsDeleteCancel">Cancel</span>
          </button>
          <button
            (click)="deleteCompany()"
            class="bg-primary hover-bg-primary-hover flex-1 rounded-[6px] px-6 py-3 text-[14px] font-[500] text-white hover:cursor-pointer">
            <span i18n="@@adminProductsDeleteConfirmButton">Delete</span>
          </button>
        </div>
      </div>
    </div>
  }
</div>
